/** Enum and literal owners. Keep these arrays in lockstep with docs/06-database.md. */
export const PET_SPECIES = ['dog', 'cat'];
export const PET_SEX = ['male', 'female', 'unknown'];
export const CONDITION_TAGS = [
    'heart', 'kidney', 'diabetes', 'liver', 'joint', 'cognitive', 'seizure',
    'respiratory', 'endocrine', 'tumor', 'dental', 'gi', 'skin', 'other',
];
export const TREATMENT_KINDS = [
    'oral', 'injection', 'topical', 'subcutaneousFluid', 'insulin', 'supplement', 'other',
];
export const LOG_STATUSES = ['given', 'skipped', 'refused', 'partial'];
export const VITAL_TYPES = [
    'sleepingRespiratoryRate', 'weight', 'bloodGlucose', 'temperature', 'heartRate',
];
export const VITAL_METHODS = ['tap15s', 'tap30s', 'tap60s', 'manual', 'scale', 'deviceImport', 'heldScale'];
export const EVENT_TYPES = [
    'vomit', 'diarrhea', 'seizure', 'collapse', 'appetiteLoss', 'lethargy', 'bleeding',
    'disorientation', 'other', 'cough', 'coughNight', 'laboredBreathing', 'exerciseIntolerance',
    'limping', 'riseDifficulty', 'stairAvoidance', 'walkStopped', 'reverseSneeze',
    'honkingCough', 'respiratoryDistress', 'hairball', 'litterBoxAvoid', 'overGrooming',
];
export const LIMBS = ['frontLeft', 'frontRight', 'hindLeft', 'hindRight', 'unknown'];
